import React, { useState } from "react";
import { FaArrowRight } from "react-icons/fa6";
import { Container } from "../home/ui";

// Right-side illustration (people building an app). Put the file at public/img/mobile-cta.png
// (transparent PNG works best on the blue banner). Until it exists, nothing is shown there.
const ctaImg = "/img/mobile-cta.png";

const MobileCta = () => {
  const [failed, setFailed] = useState(false);

  return (
    <section className="bg-white pb-[48px] lg:pb-[64px]">
      <Container className="max-w-[1320px]">
        <div className="relative flex flex-col gap-[20px] overflow-hidden rounded-[16px] bg-gradient-to-r from-[#3150E8] via-[#3D5AFE] to-[#2B44D8] px-[24px] py-[30px] text-white sm:px-[40px] lg:min-h-[150px] lg:flex-row lg:items-center lg:justify-between lg:py-[24px]">
          <div className="relative z-10">
            <h2 className="text-[24px] font-semibold leading-[1.3] sm:text-[28px]">Let&apos;s Build Your Next Mobile App</h2>
            <p className="mt-[8px] text-[15px] text-white/85">Have an idea? Let&apos;s turn it into a powerful mobile experience.</p>
            <a
              href="/contact-us"
              className="group mt-[20px] inline-flex h-[44px] items-center gap-[8px] rounded-full bg-white px-[22px] text-[14.5px] font-medium text-[#2B44D8] transition hover:-translate-y-0.5"
            >
              Get Started
              <FaArrowRight className="text-[12px] transition group-hover:translate-x-1" />
            </a>
          </div>
          {!failed && (
            <img
              src={ctaImg}
              onError={() => setFailed(true)}
              alt="Team designing a mobile app"
              className="pointer-events-none hidden h-[150px] w-auto select-none object-contain lg:block xl:absolute xl:bottom-0 xl:right-[6%] xl:h-[95%]"
            />
          )}
        </div>
      </Container>
    </section>
  );
};

export default MobileCta;
